import React from "react";

// Thin gold paisley divider — ornamental section break
export const PaisleyDivider = ({ className = "" }) => (
  <div
    className={`flex items-center justify-center gap-4 ${className}`}
    aria-hidden="true"
  >
    <span className="h-px w-24 md:w-40 bg-[#6b6353]/40" />
    <svg
      width="28"
      height="28"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 4c-7 6-11 12-11 18 0 7 5 12 11 12s11-5 11-12c0-6-4-12-11-18z"
        stroke="#6b6353"
        strokeWidth="0.8"
        fill="none"
      />
      <circle cx="24" cy="22" r="2.5" stroke="#6b6353" strokeWidth="0.8" />
      <path
        d="M24 34v10M19 40h10"
        stroke="#6b6353"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </svg>
    <span className="h-px w-24 md:w-40 bg-[#6b6353]/40" />
  </div>
);

// Corner flourish SVG — for promo banners
export const CornerFlourish = ({ className = "", flip = false }) => (
  <svg
    className={className}
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M10 110 Q 40 100 50 70 Q 55 50 80 45 Q 100 42 110 20"
      stroke="currentColor"
      strokeWidth="0.8"
      fill="none"
      opacity="0.7"
    />
    <path
      d="M30 110 Q 50 95 55 75"
      stroke="currentColor"
      strokeWidth="0.6"
      fill="none"
      opacity="0.5"
    />
    <circle cx="80" cy="45" r="3" stroke="currentColor" strokeWidth="0.6" fill="none" />
    <circle cx="50" cy="70" r="2" stroke="currentColor" strokeWidth="0.6" fill="none" />
  </svg>
);
